module.exports = __webpack_public_path__ + "static/img/detail_bayonetta_02.e5d417b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/bayonetta-microsite/detail_bayonetta_02.jpg
// module id = 227
// module chunks = 2